@if (businessDetails$ | async; as details) {
  <hr />
  <div class="row row-cols-1 row-cols-sm-2 row-cols-xl-3 g-3 mb-4">
    <div class="col">
      <app-info-block
        label="Business name"
        [value]="details.name"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="Business size"
        [value]="BusinessSize[details.size] + ' employees'"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="VAT number"
        placeholder="Add VAT number"
        [value]="details.vat_num"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="Billing address"
        placeholder="Add billing address"
        [showLineBreaks]="true"
        [value]="details.billing_address"></app-info-block>
    </div>
  </div>
  <hr />
  <div class="mt-3 text-end">
    <button
      (click)="onEditBusiness()"
      class="btn btn-primary">
      Edit business details
    </button>
  </div>
} @else {
  <app-loader></app-loader>
}
